import React from 'react';
import ToggleSwitch from '../../../../../../../../shared/components/ToggleSwitch';
import {useDispatch, useSelector} from 'react-redux';
import {setIsPackageIncluded} from '../../../../../../../../store/brand/offerBrandSlice';
import {IAllStates} from '../../../../../../../../store/rootReducer';

export function PackageIncludedToggle() {
    const dispatch = useDispatch();

    const {
        offerModalStatus,
        initialOffer: { isPackageIncluded },
    } = useSelector((state: IAllStates) => state.offerBrand);

    const onChange = (checked: boolean) => {
        dispatch(setIsPackageIncluded(checked));
    };

    if (offerModalStatus !== 'negotiate' && !isPackageIncluded) {
        return null;
    }

    return (
        <div className="d-flex align-items-center flex-wrap pt-2">
            <div>
                <ToggleSwitch
                    small={true}
                    id="package-included"
                    onChange={(checked: boolean) => onChange(checked)}
                    checked={isPackageIncluded}
                    disabled={offerModalStatus !== 'negotiate'}
                />
            </div>
            <h6 className="ml-md-2 ml-1 mb-0">{isPackageIncluded ? 'Package included' : 'Package not included'}</h6>
            <p className="mb-0 ml-1">
                - {isPackageIncluded
                    ? 'This offer includes a package.'
                    : 'This offer does not include a package.'}
            </p>
        </div>
    );
}
